import React from 'react'
import Seo from '../Seo'

const EMBED_SRC =
  'https://app.leanit101.com/benjamin?token=eyJvcmdhbml6YXRpb25JZCI6MzYsImFnZW50U2x1ZyI6ImFzc2lzdGFudC1zb2x1dGlvLXNhbGVzIiwidGVuYW50U2x1ZyI6InNvbHV0aW9uLXNvZnR3YXJlIiwiYXNzaXN0YW50TmFtZSI6IkFzc2lzdGVudGUgZGEgU29sdXRpbyBTb2Z0d2FyZSIsIm1ldGFkYXRhIjp7ImNoYW5uZWxEZWZhdWx0Ijoid2ViX2VtYmVkIn19.6be6a36a0e9316950888243a996d6ea19189d622d9aafae8bd8997aeef96a3f0&locale=pt-BR'

const SolutioSalesPage = () => {
  return (
    <section className="relative flex flex-col w-full min-h-screen overflow-hidden bg-[#050913] text-white">
      <Seo
        title="Solutio Software - Ambiente de Testes Comerciais | Lean it 101"
        description="Rota privada para validação do assistente comercial da Solutio Software."
        path="/solutio-sales"
        noindex
      />
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#070c1b] via-[#050913] to-[#050913]" />
        <div
          className="absolute -top-24 left-1/2 -translate-x-1/2 w-[620px] h-[620px] rounded-full opacity-30"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(25,162,207,0.5) 0%, rgba(25,162,207,0) 60%)',
            filter: 'blur(48px)',
          }}
        />
        <div
          className="absolute bottom-[-260px] right-[-120px] w-[560px] h-[560px] rounded-full opacity-20"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(248,129,22,0.4) 0%, rgba(248,129,22,0) 65%)',
            filter: 'blur(40px)',
          }}
        />
      </div>

      <div className="w-full max-w-5xl mx-auto px-4 py-12 md:py-16 space-y-8">
        <header className="text-center space-y-4">
          <p className="text-xs uppercase tracking-[0.4em] text-slate-400">
            Solutio Software
          </p>
          <h1 className="text-3xl md:text-4xl font-semibold">
            Solutio Software - Assistente Comercial
          </h1>
          <p className="text-base md:text-lg text-slate-200">
            Ambiente de validação para o agente comercial da Solutio durante a
            fase de PoC.
          </p>
        </header>

        <div className="w-full bg-slate-900/50 border border-slate-800 rounded-2xl shadow-2xl p-2 md:p-3">
          <iframe
            src={EMBED_SRC}
            style={{ border: 0, width: '100%', minHeight: '540px' }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Solutio Software - assistente comercial"
          />
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          <div className="bg-white/5 border border-white/10 rounded-xl p-4 backdrop-blur-sm">
            <h2 className="text-lg font-semibold mb-2">Link de teste</h2>
            <p className="text-sm text-slate-200">
              <code className="text-xs break-all text-amber-200">
                https://leanit101.com/solutio-sales
              </code>
            </p>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-xl p-4 backdrop-blur-sm">
            <h2 className="text-lg font-semibold mb-2">Objetivo</h2>
            <p className="text-sm text-slate-200">
              Validar abordagem comercial, qualificação e convite para reunião.
            </p>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-xl p-4 backdrop-blur-sm">
            <h2 className="text-lg font-semibold mb-2">Escopo</h2>
            <p className="text-sm text-slate-200">
              Rota privada de PoC para testes internos do time Solutio.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SolutioSalesPage
